import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import kcService from '../services/kc.service';

const KiteConnectRedirect = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        const requestToken = searchParams.get('request_token');
        const status = searchParams.get('status');

        console.log('Request Token:', requestToken);
        console.log('Status:', status);

        if (status === 'success' && requestToken) {

            kcService.getCallbackToken({ requestToken: requestToken })
                .then((response) => {
                     navigate('/kc/orders');
                    console.log('Callback Token Response:', response.data);
                })
                .catch((error) => {
                    console.error('Error fetching callback token:', error);
                })
            
            // window.location.href = '/kc/orders';
        } else {
            console.error('Missing parameters in the URL');
        }
    }, []);
    return (
        <div className="container d-flex justify-content-center align-items-center vh-100">
            <div className="card p-4" style={{ width: '400px' }}>
                <h3 className="text-center mb-4">Please wait connecting</h3>
                <span className="text-center">Do not refresh</span>
            </div>
        </div>
    );
};

export default KiteConnectRedirect;